import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'split',
    standalone: false
})
export class SplitPipe implements PipeTransform {

    transform(value: string, delimiter: string): string[] {
        return value.split(delimiter);
    }

}

@NgModule({
    declarations: [SplitPipe],
    exports: [SplitPipe],
})
export class SplitPipeModule {}